export function createActions(baseType) {
  return {
    request: (payload) => ({ type: baseType.REQUEST, payload }),
    success: (payload) => ({ type: baseType.SUCCESS, payload }),
    fail: (payload) => ({ type: baseType.FAIL, payload }),
  };
}
